import { render, staticRenderFns } from "./Komship.vue?vue&type=template&id=1a20bc93&scoped=true&"
import script from "./Komship.vue?vue&type=script&lang=js&"
export * from "./Komship.vue?vue&type=script&lang=js&"
import style0 from "./Komship.vue?vue&type=style&index=0&id=1a20bc93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a20bc93",
  null
  
)

export default component.exports